<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <fuse-alert
        *ngIf="showAlert"
        class="fixed z-50 top-4 right-5"
        [name]="'alertCrear'"
        [appearance]="'border'"
        [dismissible]="false"
        [showIcon]="true"
        [type]="alert.type"
        @fadeInRight>
        {{ alert.message }}
    </fuse-alert>
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class="text-black title-6 md:title-3">Mantenedor de correos</h1>
    </div>
    <div class="flex items-center gap-5 mt-5">
        <mat-form-field hideRequiredMarker appearance="fill" class="flex-1">
            <mat-label>Tipo de correo</mat-label>
            <mat-select class="h-[54px]" required [(ngModel)]="correoSelected" #tipoCorreo="ngModel" (selectionChange)="getCorreo()">
                <mat-option *ngFor="let option of opcionesCorreo" [value]="option.VALOR">
                    {{ option.VALOR ? option.VALOR : 'Seleccione' }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-slide-toggle color="accent" [(ngModel)]="infoCorreo.active"></mat-slide-toggle>
    </div>
    <mat-form-field class="w-full h-[5rem]" hideRequiredMarker>
        <mat-label>Asunto del correo</mat-label>
        <input
            matInput
            type="text"
            [(ngModel)]="infoCorreo.subject"
            placeholder="Asunto aquí"
            class="h-[26px]"
            maxlength="50"
            pattern="^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ .,]{1,50}$"
            required
            #nombreUsuario="ngModel" />
    </mat-form-field>

    <!-- EDITOR -->
    <div class="py-5">
        <editor [(ngModel)]="infoCorreo.body" [init]="init" #editor="ngModel" required> </editor>
    </div>

    <div class="flex items-center gap-5 p-4 my-5 rounded-lg bg-primary-gray-02">
        <mat-icon class="w-[20px] h-[20px] min-w-[20px] min-h-[20px]" svgIcon="icons:info-icon"> </mat-icon>
        <p class="paragraph-4 text-primary-black-01">
            Puedes ingresar variables para mostrar datos del sistema,
            <span class="cursor-pointer text-primary-blue-01" (click)="modalVariables = true">conoce las variables.</span>
        </p>
    </div>
    <button
        mat-flat-button
        color="primary"
        class="w-full md:w-48"
        [disabled]="guardandoCorreo || !nombreUsuario.valid || !editor.valid || !tipoCorreo.valid"
        (click)="guardarCorreo()">
        <span *ngIf="!guardandoCorreo"> Guardar </span>
        <mat-progress-spinner *ngIf="guardandoCorreo" [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
    </button>
</main>

<!-- Modal Variables -->
<div *ngIf="modalVariables" class="fixed inset-0 grid w-full h-full p-5 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div
        class="w-full max-w-[597px] h-full max-h-[620px] md:max-h-[640px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-14 md:pb-10 relative overflow-auto no-scrollbar">
        <button
            class="absolute top-4 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="modalVariables = false">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="mt-5 title-8">Variables disponibles para personalizar el correo</h1>
        <div class="flex justify-between mt-10">
            <div class="flex flex-col gap-3 text-black paragraph-4">
                <p class="paragraph-3">Variable</p>
                <p>&#123;nombre_cliente&#125;</p>
                <p>&#123;cédula_identidad&#125;</p>
                <p>&#123;monto_total&#125;</p>
                <p>&#123;mes&#125;</p>
                <p>&#123;año&#125;</p>
                <p>&#123;fecha_contrato&#125;</p>
                <p>&#123;representante&#125;</p>
                <p>&#123;fecha_escritura&#125;</p>
                <p>&#123;domicilio&#125;</p>
                <p>&#123;comuna&#125;</p>
                <p>&#123;fecha&#125;</p>
            </div>
            <div class="flex flex-col gap-3 text-black paragraph-4">
                <p class="paragraph-3">Descripción</p>
                <p>Nombre del receptor del documento</p>
                <p>Indentificado fiscal del receptor del documento</p>
                <p>Monto total del pagaré</p>
                <p>Mes de verificación del pago</p>
                <p>Año de verificación del pago</p>
                <p>Fecha de firma del contrato</p>
                <p>Nombre de quien comparece por Claro</p>
                <p>Fecha escritura pública</p>
                <p>Dirección del receptor del documento</p>
                <p>Comuna del receptor del documento</p>
                <p>Fecha de generación del pagaré</p>
            </div>
        </div>
        <div class="flex justify-between mt-5 md:hidden">
            <div class="flex flex-col gap-3 text-black paragraph-4">
                <p>&#123;nombre_cliente&#125;</p>
                <p>Nombre del receptor del documento</p>
                <p>&#123;cédula_identidad&#125;</p>
                <p>Indentificado fiscal del receptor del documento</p>
                <p>&#123;monto_total&#125;</p>
                <p>Monto total del pagaré</p>
                <p>&#123;mes&#125;</p>
                <p>Mes de verificación del pago</p>
                <p>&#123;año&#125;</p>
                <p>Año de verificación del pago</p>
                <p>&#123;fecha_contrato&#125;</p>
                <p>Fecha de firma del contrato</p>
                <p>&#123;representante&#125;</p>
                <p>Nombre de quien comparece por Claro</p>
                <p>&#123;fecha_escritura&#125;</p>
                <p>Fecha escritura pública</p>
                <p>&#123;domicilio&#125;</p>
                <p>Dirección del receptor del documento</p>
                <p>&#123;comuna&#125;</p>
                <p>Comuna del receptor del documento</p>
                <p>&#123;fecha&#125;</p>
                <p>Fecha de generación del pagaré</p>
            </div>
        </div>
    </div>
</div>
